import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { auth } from "../../firebaseConfig";

export const getApplicationStatus = async () => {
  const user = auth.currentUser;
  try {
    const docRef = doc(db, "Advisers", user.uid, "Personal Details", "Data");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        // console.log("Document data:", docSnap.data().recruitmentApplication);
      return docSnap.data().recruitmentApplication; // Return the form data
    } else {
      // console.log("No such document for Section 9!");
      return false;
    }
  } catch (error) {
    // console.error("Error fetching data", error);
  }
};
